import { DarkModeToggleLink, NavLink, NormalNavLink, SocialLink } from './navlink';
import { PagePaths } from '../lib/pagePaths';

export class TylerNavbar {
  public navButtonClasses: string;
  private navbarLinks: NavLink[];

  getNavButtonClasses(navLink: NavLink): string {
    if (navLink.isNavLinkActive) {
      return 'nav-buttons active';
    }
    return this.navButtonClasses;
  }

  getAriaAttribute(navLink: NavLink): string {
    return navLink.isNavLinkActive ? '(current)' : '';
  }

  constructor(activeLinkName?: string) {
    this.navButtonClasses = 'nav-buttons';
    this.navbarLinks = [];
    let homeLinkActive = false;
    let portfolioLinkActive = false;
    let resumeLinkActive = false;
    let inquiriesLinkActive = false;
    switch (activeLinkName) {
      case 'Home':
        homeLinkActive = true;
        break;
      case 'My Portfolio':
        portfolioLinkActive = true;
        break;
      case 'My Resume':
        resumeLinkActive = true;
        break;
      case 'Inquiries':
        inquiriesLinkActive = true;
        break;
      default:
        break;
    }
    this.navbarLinks.push(new NormalNavLink('Home', PagePaths.paths.home, homeLinkActive, 1));
    this.navbarLinks.push(new NormalNavLink('My Portfolio', PagePaths.paths.portfolio, portfolioLinkActive, 2));
    this.navbarLinks.push(new NormalNavLink('My Resume', PagePaths.paths.resume, resumeLinkActive, 3));
    this.navbarLinks.push(new NormalNavLink('Inquiries', PagePaths.paths.inquiries, inquiriesLinkActive, 4));
    this.navbarLinks.push(new SocialLink('Facebook', 'fab fa-lg fa-facebook-f', 'facebook', 5));
    this.navbarLinks.push(new SocialLink('Twitter', 'fab fa-lg fa-twitter', 'twitter', 6));
    this.navbarLinks.push(new SocialLink('LinkedIn', 'fab fa-lg fa-linkedin', 'linkedin', 7));
    this.navbarLinks.push(new DarkModeToggleLink(8));
  }

  public get getNavbar(): NavLink[] {
    return this.navbarLinks;
  }

  public isNormalNavLink(obj: NavLink): boolean {
    return obj instanceof NormalNavLink;
  }

  public isSocialNavLink(obj: NavLink): boolean {
    return obj instanceof SocialLink;
  }

  public isDarkModeToggleLink(obj: NavLink): boolean {
    return obj instanceof DarkModeToggleLink;
  }
}
